import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiYoutube, FiUsers, FiShield} = FiIcons;

const Footer = () => {
  const quickLinks = [
    {name: 'About', href: '#about'},
    {name: 'Watch', href: 'http://link.lrcs.nyc/YTSL'},
    {name: 'Scam Help', href: '/scam-assistance', internal: true},
    {name: 'Contact', href: '#contact'},
    {name: 'Press Kit', href: '#press'},
    {name: 'Terms', href: '#terms'}
  ];

  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-16">
      <div className="container mx-auto px-6">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {/* Logo/Brand */}
          <div className="mb-8">
            <h3 className="text-3xl font-bold bg-gradient-to-r from-[#ffc700] to-cyan-400 bg-clip-text text-transparent mb-2">
              Linda Roberts Calls Scammers
            </h3>
            <p className="text-lg text-gray-400 font-medium">
              Where Sass Meets Cyber Safety
            </p>
          </div>

          {/* Social Media */}
          <motion.div 
            className="flex justify-center gap-6 mb-8"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <a 
              href="http://link.lrcs.nyc/YTSL" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group bg-red-600 hover:bg-red-700 p-4 rounded-full transition-all duration-300 transform hover:scale-110"
            >
              <SafeIcon icon={FiYoutube} className="text-2xl text-white group-hover:animate-pulse" />
            </a>
            <a 
              href="https://www.youtube.com/@LindaRobertsCallsScammers" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group bg-[#ffc700] hover:bg-[#ffb700] p-4 rounded-full transition-all duration-300 transform hover:scale-110"
            >
              <SafeIcon icon={FiUsers} className="text-2xl text-black group-hover:rotate-12 transition-transform" />
            </a>
          </motion.div>

          {/* Quick Links */}
          <motion.div 
            className="flex flex-wrap justify-center gap-6 mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {quickLinks.map((link, index) => (
              link.internal ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-400 hover:text-[#ffc700] font-medium transition-colors duration-300 hover:underline"
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  target={link.href.startsWith('http') ? '_blank' : '_self'}
                  rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''}
                  className="text-gray-400 hover:text-[#ffc700] font-medium transition-colors duration-300 hover:underline"
                >
                  {link.name}
                </a>
              )
            ))}
          </motion.div>

          {/* Mission Statement */}
          <motion.div 
            className="max-w-2xl mx-auto mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">
              <SafeIcon icon={FiShield} className="text-3xl text-[#ffc700] mx-auto mb-3" />
              <p className="text-gray-300 leading-relaxed">
                Protecting people from scammers through education, awareness, and a healthy dose of New York attitude. Together, we make the internet a safer place for everyone.
              </p>
            </div>
          </motion.div>

          {/* Copyright and Legal */}
          <motion.div 
            className="border-t border-gray-800 pt-8"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
              <p>
                © 2024 Linda Roberts Calls Scammers. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a href="#privacy" className="hover:text-gray-400 transition-colors">
                  Privacy Policy
                </a>
                <span>•</span>
                <a href="#terms" className="hover:text-gray-400 transition-colors">
                  Terms of Service
                </a>
                <span>•</span>
                <Link to="/scam-assistance" className="hover:text-gray-400 transition-colors">
                  Scam Assistance
                </Link>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;